import React, { useContext } from 'react'
import { LanguageContext } from '../../container/Language'
import LanguageSelector from '../LanguageSelector'

const Sidebar = () => {
    const { dictionary } = useContext(LanguageContext)
    return (
        <>
            <div className="s_overlay"></div>
            <div className="content-sidebar">
                <div className="sidebar-wrap search-form">
                    <aside id="secondary" className="widget-area">
                        <section className="widget">
                            <h2 className="widget-title">
                                <span className="widget-title-span"><span className="first-word">{dictionary.sidebar.language.firstWord}</span> {dictionary.sidebar.language.secondWord}</span>
                            </h2>
                            <LanguageSelector />
                        </section>
                    </aside>
                </div>
                <span className="close"></span>
            </div>
        </>
    )
}

export default Sidebar